import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { PlanEditPresenter } from "./presenter";
import { usePlanEditQuery } from "../../../model/repository/existing/query/fetch-plan";

type Props = {
	hotelID: string;
	planID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const PlanEditContainer = ({ hotelID, planID, activeLangCode, navigator }: Props) => {
	const serverModel = usePlanEditQuery({ hotelID, planID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })} />;
	}

	return <PlanEditPresenter serverModel={serverModel} activeLangCode={activeLangCode} navigator={navigator} />;
};

PlanEditContainer.displayName = "PlanEditContainer";
